var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { breakpoints } from "../_styleguide/_breakpoints";
import { convertToCurrency, flattenColumn, thousands } from "../d3-services/_helpers";
import { filterLatest, getNeededColumns } from '../d3-services/data.functions';
import { GraphControllerV2 } from "./graph-v2";
var TickerNumbers = /** @class */ (function (_super) {
    __extends(TickerNumbers, _super);
    function TickerNumbers(main, data, element, mapping, segment) {
        var _this = _super.call(this, main, data, element, mapping, segment) || this;
        _this.main = main;
        _this.data = data;
        _this.element = element;
        _this.mapping = mapping;
        _this.segment = segment;
        _this.pre();
        return _this;
    }
    TickerNumbers.prototype.pre = function () {
        this._addMargin(0, 0, 0, 0);
        this._addPadding(0, 4, 0, 0);
    };
    TickerNumbers.prototype.init = function () {
        var self = this;
        this.element.style.display = 'flex';
        this.element.style.flexDirection = 'row';
        this.element.style.flexWrap = 'wrap';
        this.element.style.flexDirection = 'column-reverse';
        this.element.style.justifyContent = 'space-between';
        this.element.style.alignItems = 'flex-start';
        this.element.style.lineHeight = '1.33';
        this.element.style.margin = 'auto';
        if (window.innerWidth < breakpoints.sm) {
            this.element.style.width = '100%';
            this.element.style.margin = '1.5rem auto';
        }
        else if (window.innerWidth < breakpoints.md) {
            this.element.style.flex = '0 0 50%';
            this.element.style.margin = '2rem auto 0 auto';
            this.element.style.height = '100%';
        }
        else {
            this.element.style.flexWrap = 'nowrap';
            this.element.style.flex = '0 0 25%';
            this.element.style.height = '100%';
        }
        if ([].slice.call(this.element.parentElement.parentElement.classList).indexOf('img-graph-container-ipad-6') > -1) {
            this.element.style.flex = '0 0 50%';
        }
        self.update(this.data, this.segment);
    };
    TickerNumbers.prototype.prepareData = function (data) {
        var neededColumns = getNeededColumns(data, this.mapping);
        return {
            "history": null,
            "latest": filterLatest(data, neededColumns),
            "slice": null
        };
    };
    TickerNumbers.prototype.redraw = function (data) {
        // let value =  (this.graphObject.config.extra.decimal) ? data.latest[this.yParameter ] : convertToCurrency(Math.round(data.latest[this.yParameter ]));
        // let el = this.element.querySelector('.number') as HTMLElement;
        // el.innerText = (value > 9999) ? thousands(value) : value;
    };
    TickerNumbers.prototype.draw = function (data) {
        var table = document.createElement('table');
        table.style.lineHeight = '1.55';
        for (var _i = 0, _a = this.mapping.parameters[0]; _i < _a.length; _i++) {
            var mapping = _a[_i];
            var row = document.createElement('tr');
            var key = document.createElement('td');
            key.innerText = mapping['label'];
            key.setAttribute('width', '120');
            row.appendChild(key);
            var value = document.createElement('td');
            var v = data.latest[flattenColumn(mapping.column)];
            switch (mapping.format) {
                case "currency":
                    v = convertToCurrency(parseInt(v));
                    break;
                case "thousands":
                    v = thousands(v) + ' dossiers';
                    break;
                case "decimal":
                    v = (Math.round(parseFloat(v) * 10) / 10).toString();
            }
            value.innerText = v;
            row.appendChild(value);
            table.appendChild(row);
        }
        this.element.appendChild(table);
    };
    TickerNumbers.prototype.update = function (newData, segment) {
        var self = this;
        var data = self.prepareData(newData);
        self.draw(data);
        self.redraw(data);
        window.addEventListener("resize", function () { return self.redraw(data); }, false);
    };
    return TickerNumbers;
}(GraphControllerV2));
export default TickerNumbers;
